import { render, staticRenderFns } from "./RouteManage.vue?vue&type=template&id=46d1a5c6&scoped=true"
import script from "./RouteManage.vue?vue&type=script&lang=js"
export * from "./RouteManage.vue?vue&type=script&lang=js"
import style0 from "./RouteManage.vue?vue&type=style&index=0&id=46d1a5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d1a5c6",
  null
  
)

export default component.exports